module.exports = __webpack_public_path__ + "static/block-ohio-tee-5ff1b33f74b9c918fe21484bd9bfab46.webp";